<template>
  <div id="tryout-group">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Tryout</li>
      <li class="active">Daftar Tryout Serial</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Tryout Serial</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" @click="createSerial()" class="btn btn-success btn-xs"><span class="fa fa-plus"></span> Tryout Serial</button>
            </div>
            <h4 class="panel-title">Tryout Group</h4>
          </div>
          <div class="panel-body">
            <app-datatable :items="rows" :has-action="true" :headers="headers"
              v-on:selected="selectedRow = $event" 
              v-on:dblClicked="editRow($event)"
              v-on:deleted="deleteSerial($event)" ></app-datatable>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import DataTable from '@/components/plugins/DataTable'
import TryoutService from '@/services/tryout.js'
import Spinner from '@/components/plugins/Spinner'
import Moment from 'moment'

export default {
    name: 'app-serial',
    components: {
      'app-spinner': Spinner,
      'app-datatable': DataTable
    },
    data: function () {
      return {
        isLoading: false,
        rows: [],
        headers: ['Nama', 'Kelas', 'Tipe' , 'Open', 'Close']
      }
    },
    methods: {
      editRow: function (row) {
        this.$router.push({ path: '/serial/form', query: {id: row.id} })
      },
      createSerial: function () {
        this.$router.push({ path: '/serial/form' })
      },
      deleteSerial: function (data) {
        var context = this
        var dataid = data.id
        var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
        if (confirmed) {
          this.isLoading = true
          TryoutService.deleteTryoutSerial(dataid, function (result) {
            if (result.success) {
              alert('Data Terhapus')
              context.isLoading = false
              context.fetchData()
               this.$router.push({ path: '/serial' })
            }
          })
        }
      },
      fetchData: function () {
        var context = this
        this.isLoading = true
        this.rows = []
        TryoutService.getListOfTryoutSeries(function (response) {
          if (response.success) {
            response.data.forEach(function (groupSeries) {
              var openedAt = groupSeries.opened_at != null ? Moment(groupSeries.opened_at).format('DD/MM/YYYY, hh:mm:ss') : '-'
              var closedAt = groupSeries.closed_at != null ? Moment(groupSeries.closed_at).format('DD/MM/YYYY, hh:mm:ss') : '-'

              var row = {
                id: groupSeries.id,
                data: [groupSeries.title, groupSeries.grade, groupSeries.type, openedAt, closedAt]
              }

              context.rows.push(row)
            })

            context.isLoading = false
          }
        }).catch(function (error) {
          context.isLoading = false
        })
      }
    },
    mounted: function () {
      this.fetchData()
    }
}
</script>


// WEBPACK FOOTER //
// Serial.vue?73525233